import { connect } from "react-redux";
import useQueryParams from "../../customHooks/useQueryParams";
import { Helmet } from "react-helmet-async";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import Select, { components } from "react-select";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import { Controller, useForm } from "react-hook-form";
import {
  cleanMessageDocument,
  getDocument,
  getDocumentHistory,
  loadEmptyDocument,
  saveDocument,
  disableLoadingDocument,
  cleanIdDocumentDuplicate,
  duplicateDocument,
  getDocumentPreview,
  putWorkflowChangeStatus,
  cleanMessageWorkflow,
  getDownloadDocument,
} from "../../store/actions";
import { useCallback, useEffect, useRef, useState } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { setValuesHookForm } from "../../helpers/load_object_hook_form";
import { fieldsMessage } from "../../helpers/utils/fieldsMessage";
import { useNavigate } from "react-router-dom";
import DocumentBuider from "../../components/DocumentBuider/DocumentBuider";
import { documentBuilderVariants } from "../../enums/documentBuiderVariants";
import BusinessSelect from "../../components/BusinessSelect/BusinessSelect";
import RegionSelect from "../../components/RegionSelect/RegionSelect";
import LabelWithHelp from "../../components/LabelWithHelp/LabelWithHelp";
import CheckboxField from "../../components/CheckboxField/CheckboxField";
import TemplateSelect from "../../components/TemplateSelect/TemplateSelect";
import StatusList from "../../components/StatusList/StatusList";
import stringify from "json-stable-stringify";
import { buildSnapshot } from "../../helpers/utils/buildSnapshot";
import useAlert from "../../customHooks/useAlert";
import openPdfFromBase64 from "../../helpers/openPdfFromBase64";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { workflowChangeStatusAlertMessages } from "../../helpers/workflowChangeStatusAlertMessages";
import downloadBase64File from "../../helpers/downloadBase64File";

const DocumentDetail = ({
  document,
  loadingDocument,
  messageDocument,
  isDocumentSave,
  saveDocumentRequest,
  getDocumentPreviewRequest,
  postDocumentDuplicateRequest,
  getDocumentRequest,
  loadEmptyDocument,
  cleanMessageDocument,
  getDocumentHistoryRequest,
  disableLoadingDocument,
  documentIdDuplicate,
  errorDocumentDuplicate,
  cleanIdDocumentDuplicate,
  errorLoadingDocument,
  errorLoadingDocumentHistory,
  documentPreview,
  errorDocumentPreview,
  putWorkflowChangeStatusRequest,
  workflow,
  loadingWorkflow,
  errorMessageWorkflow,
  cleanMessageWorkflow,
  documentDownload,
  errorDocumentDownload,
  getDownloadDocumentRequest,
}) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      active: true,
    }
  });
  const initialHasRef = useRef(null);
  const saveActionRef = useRef(null);
  const titlePreviewRef = useRef("");
  const successMessageAlertRef = useRef("");
  const { confirmAlert, successAlert, errorAlert, okAlert, confirmWorkflowChangeStatus } = useAlert();
  const CustomClear = (props) => (
    <components.ClearIndicator {...props}>
      <i className="fas fa-times" style={{ fontSize: "14px", color: "#888" }} />
    </components.ClearIndicator>
  );
  const customStyles = {
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? "#0576B960" : "#0576B9",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9599AD",
      fontWeight: "400",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const alertModal = withReactContent(Swal);
  const navigate = useNavigate();
  const params = useQueryParams();

  const id = params.get("id");
  const idHistory = params.get("idHistory");

  const [content, setContent] = useState([]);
  const [contentError, setContentError] = useState(null);

  function handleBack() {
    loadEmptyDocument();
    navigate("/documents");
  }
  function validateContent() {
    return content.length > 0;
  }
  async function handleSave(values) {
    saveActionRef.current = null;

    const isValidContent = validateContent();
    if (!isValidContent) {
      setContentError(true);
      return;
    }
    setContentError(false);

    const isEdit = id !== null;
    const baseBody = {
      title: values.title,
      description: values.description,
      active: values.active,
      idRegion: values.region?.value,
      idBusiness: values.business?.value,
      idTemplate: values.template?.value,
      type: values.type?.value,
      products: values.products,
      content,
    };
    const body = isEdit ? { id, ...baseBody } : baseBody;

    if(values.status !== 'Draft') {
      if(isEdit) {
        const result = await confirmAlert("Attention! Saving this document will change its status to Draft. Do you want to continue?")
      
        if(!result.isConfirmed) return;
      }
    }
    
    await saveDocumentRequest({ 
      body, 
      method: isEdit ? "PUT" : "POST" 
    });
  }
  function handleDuplicate() {
    if (id === null) return;

    const isValidContent = validateContent();
    if (!isValidContent) {
      setContentError(true);
      return;
    }
    setContentError(false);

    const values = getValues();

    const currentSnapshot = buildSnapshot({
      values,
      content,
    });
    if (stringify(initialHasRef.current) === stringify(currentSnapshot)) {
      saveActionRef.current = "DUPLICATE_ONLY";
      postDocumentDuplicateRequest({ documentId: id });
      return;
    } else {
      confirmAlert(
        "You have unsaved changes. Do you want to save before duplicating?",
      ).then((result) => {
        if (result.isConfirmed) {
          saveActionRef.current = "SAVE_AND_DUPLICATE";
          saveDocumentRequest({
            body: {
              id,
              ...currentSnapshot,
            },
            method: "PUT",
          });
        }
      });
    }
  }
  function handlePreview() {
    if (!id) return;

    const isValidContent = validateContent();
    if (!isValidContent) {
      setContentError(true);
      return;
    }
    setContentError(false);

    const values = getValues();
    titlePreviewRef.current = values.title ?? "Document Preview";
    const currentSnapshot = buildSnapshot({
      values,
      content,
    });

    if (stringify(initialHasRef.current) === stringify(currentSnapshot)) {
      saveActionRef.current = "PREVIEW_ONLY";
      getDocumentPreviewRequest({ documentId: id });
      return;
    } else {
      confirmAlert(
        "You have unsaved changes. Do you want to save before previewing?",
      ).then((result) => {
        if (result.isConfirmed) {
          saveActionRef.current = "SAVE_AND_PREVIEW";
          saveDocumentRequest({
            body: {
              id,
              ...currentSnapshot,
            },
            method: "PUT",
          });
        }

        return;
      });
    }
  }
  function handleSaveAndSendToReview(values) {
    const method = "PUT-REVIEW";

    if (!document?.status) return;
    const statusDraft = document.status

    if (!validateContent()) {
      setContentError(true);
      return;
    }
    setContentError(false);

    const currentSnapshot = buildSnapshot({ values, content });
    const hasChanges = stringify(initialHasRef.current) !== stringify(currentSnapshot);

    confirmWorkflowChangeStatus(
      {html: workflowChangeStatusAlertMessages[statusDraft]?.Question}
      ).then((result) => {
      if (!result.isConfirmed) return;
      
      successMessageAlertRef.current = workflowChangeStatusAlertMessages[statusDraft]?.Success;
      
      if (hasChanges) {
        saveActionRef.current = "SAVE_AND_SEND_REVIEW";
        saveDocumentRequest({
          body: { id, ...currentSnapshot },
          method,
        });
      } else {
        putWorkflowChangeStatusRequest({ idDocument: id, type: "Review" });
      }
    });
  }
  function handleWorkflowChangeStatus(action) {
    if(!action || !workflowChangeStatusAlertMessages[action]) return;
    
    successMessageAlertRef.current = workflowChangeStatusAlertMessages[action]?.Success;
    
    confirmWorkflowChangeStatus(
      {html: workflowChangeStatusAlertMessages[action]?.Question},
      ).then((result) => {
      if (!result.isConfirmed) return;
        putWorkflowChangeStatusRequest({ idDocument: id, type: action });
    });
  }
  function handleDownload(type) {
    if (!id) return;

    getDownloadDocumentRequest({
      documentId: id,
      type,
    });
  }
  
  const handleBuilderChange = useCallback((data) => {
    setContent(data.content);
  }, []);
  const actions = useContextActions({
    context: "document",
    screen: "detail",
  })
  const editableWithSave = actions.some(e => e === "save")

  useEffect(() => {
    if (id !== null) {
      getDocumentRequest({ documentId: id });
    } else if (idHistory !== null) {
      getDocumentHistoryRequest({ idHistory });
    } else {
      disableLoadingDocument();
    }

    return () => {
      loadEmptyDocument();
      cleanMessageDocument();
      cleanIdDocumentDuplicate();
    };
    // eslint-disable-next-line
  }, [id]);
  useEffect(() => {
    if (isDocumentSave !== null) {
      if (isDocumentSave) {
        if(saveActionRef.current === "SAVE_AND_PREVIEW") {
          okAlert(
            'Document saved successfully!'
          )
          .then((result) => {
            if(result.isConfirmed) {
              cleanMessageDocument();
              getDocumentPreviewRequest({ documentId: id });
            }
            if (result.isDismissed) {
              cleanMessageDocument();
            }
            saveActionRef.current = null;
            initialHasRef.current = buildSnapshot({
              values: getValues(),
              content,
            });
          });
          return;
        }
        if(saveActionRef.current === "SAVE_AND_SEND_REVIEW") {
          successAlert(
            workflowChangeStatusAlertMessages[document?.status]?.Success || "All set! Your document is waiting for approval.",
            {
              didClose: () => {
                cleanMessageDocument();
                loadEmptyDocument();
                navigate("/documents");
              }
            }
          )
          return;
        }
        successAlert(
          `Document ${id === null ? "created" : "updated"} successfully!`,
          {
            didClose: () => {
              if (saveActionRef.current === "SAVE_AND_PREVIEW") {
                cleanMessageDocument();
                getDocumentPreviewRequest({ documentId: id });
                initialHasRef.current = buildSnapshot({
                  values: getValues(),
                  content,
                });
                saveActionRef.current = null;
              } else if (saveActionRef.current === "SAVE_AND_DUPLICATE") {
                cleanMessageDocument();
                postDocumentDuplicateRequest({ documentId: id });
                initialHasRef.current = buildSnapshot({
                  values: getValues(),
                  content,
                });
                saveActionRef.current = null;
              } else {
                cleanMessageDocument();
                loadEmptyDocument();
                navigate("/documents");
              }
            },
          },
        );
      } else {
        errorAlert(messageDocument ?? "Something wrong, try again later.", {
          didClose: () => {
            cleanMessageDocument();
          },
        });
      }
    }
    // eslint-disable-next-line
  }, [isDocumentSave]);
  useEffect(() => {
    if (errorLoadingDocument !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (errorLoadingDocument) {
            if (result.dismiss) {
              cleanMessageDocument();
              loadEmptyDocument();
              navigate("/documents");
            }
          }
          if (result.dismiss) {
            cleanMessageDocument();
            loadEmptyDocument();
          }
        });
    }
    // eslint-disable-next-line
  }, [errorLoadingDocument]);
  useEffect(() => {
    if (errorLoadingDocumentHistory !== null) {
      alertModal
        .fire({
          title: "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (errorLoadingDocumentHistory) {
            if (result.dismiss) {
              cleanMessageDocument();
              loadEmptyDocument();
              navigate("/documents");
            }
          }
          if (result.dismiss) {
            cleanMessageDocument();
            loadEmptyDocument();
          }
        });
    }
    // eslint-disable-next-line
  }, [errorLoadingDocumentHistory]);
  useEffect(() => {
    if (documentIdDuplicate !== null) {
      if (documentIdDuplicate) {
        successAlert("Document duplicated successfully!", {
          text: "You will be redirected to the copied document!",
          timer: undefined,
          showConfirmButton: true,
          customClass: {
            confirmButton: "btn btn-braskemPrimary btn-lg px-5",
          },
          didClose: () => {
            cleanIdDocumentDuplicate();
            loadEmptyDocument();
            navigate("/document?id=" + documentIdDuplicate);
          },
        });
        return;
      }
      if (errorDocumentDuplicate) {
        errorAlert(
          errorDocumentDuplicate ? errorDocumentDuplicate : "Try again later!",
          {
            didClose: () => {
              cleanIdDocumentDuplicate();
            },
          },
        );
      }
    }
    // eslint-disable-next-line
  }, [documentIdDuplicate, errorDocumentDuplicate]);
  useEffect(() => {
    if (!document) return;

    setValuesHookForm(document, setValue);

    setValue("region", { value: document.idRegion });
    setValue("business", { value: document.idBusiness });
    setValue("template", { value: document.idTemplate });
    setValue("type", { value: document.type });

    setValue("active", document.active ?? true);

    let normalizeContent = [];

    if (Array.isArray(document.content)) {
      normalizeContent = document.content.map((block) => ({
        idSnippet: block.idSnippet,
        idSection: block.idSection,
        order: block.order,
        type: block.type,
        pageBreak: block.pageBreak,
      }));

      setContent(normalizeContent);
    }

    initialHasRef.current = buildSnapshot({
      values: {
        title: document.title,
        description: document.description,
        region: { value: document.idRegion },
        business: { value: document.idBusiness },
        template: { value: document.idTemplate },
        type: { value: document.type },
        products: document.products,
        active: document.active,
      },
      content: normalizeContent,
    });
    // eslint-disable-next-line
  }, [document]);
  useEffect(() => {
    if (contentError && validateContent()) {
      setContentError(false);
    }
    // eslint-disable-next-line
  }, [content]);
  useEffect(() => {
    if (documentPreview) {
      openPdfFromBase64(documentPreview.base64);
      getDocumentRequest({ documentId: id });
      saveActionRef.current = null;
      cleanMessageDocument();
      return;
    }
    if (errorDocumentPreview) {
      saveActionRef.current = null;
      errorAlert(
        errorDocumentPreview ? errorDocumentPreview : "Try again later!",
        {
          didClose: () => {
            cleanMessageDocument();
          },
        },
      );
    }

    return () => {
      saveActionRef.current = null;
      cleanMessageDocument();
    };
    // eslint-disable-next-line
  }, [documentPreview, errorDocumentPreview]);
  useEffect(() => {
    if (workflow !== null) {
      if (workflow) {
        successAlert(
          successMessageAlertRef.current,
          {
            didClose: () => {
              navigate("/documents");
            }
          }
        )
      }
    } else {
      if (errorMessageWorkflow) {
        errorAlert(
          errorMessageWorkflow ? errorMessageWorkflow : "Try again later!",
        ).then((result) => {
          if (result.dismiss) {
            cleanMessageWorkflow();
          }
        });
      }
    }

    return () => {
      saveActionRef.current = null;
      cleanMessageWorkflow();
    }
    // eslint-disable-next-line
  }, [workflow, errorMessageWorkflow]);
  useEffect(() => {
    if (documentDownload) {
      const { base64, fileName, extension } = documentDownload;

      downloadBase64File(base64, fileName, extension);

      cleanMessageDocument();
      return;
    }

    if (errorDocumentDownload) {
      errorAlert(
        errorDocumentDownload || "Try again later!",
        {
          didClose: () => {
            cleanMessageDocument();
          },
        }
      );
    }

    // eslint-disable-next-line
  }, [documentDownload, errorDocumentDownload]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Document</title>
      </Helmet>

      <Container fluid>
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form onSubmit={handleSubmit(handleSave)}>
                  {loadingDocument || loadingWorkflow ? (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: "400px", width: "100%" }}
                    >
                      <Spinner
                        color="primary"
                        style={{ height: "5rem", width: "5rem" }}
                      />
                    </div>
                  ) : (
                    <>
                      <div className="d-flex flex-wrap justify-content-between my-2">
                        <h2>
                          {id === null
                            ? idHistory === null
                              ? "CREATE"
                              : "VIEW"
                            : "EDIT"}{" "}
                          DOCUMENT
                        </h2>

                        <div className="d-flex justify-content-end flex-wrap gap-2">
                          {
                              <>
                                <ButtonCustom
                                  type="cancel"
                                  onClick={() => handleBack()}
                                />
                          
                                <ActionButtons 
                                  actions={actions}
                                  status={document?.status}
                                  handlers={{
                                    preview: handleSubmit(handlePreview),
                                    save: () => (handleSubmit(handleSave))(),
                                    save_send: handleSubmit(handleSaveAndSendToReview),
                                    duplicate: handleSubmit(handleDuplicate),
                                    reject: () => handleWorkflowChangeStatus("Rejected"),
                                    approve: () => handleWorkflowChangeStatus("Approved"),
                                    publish: () => handleWorkflowChangeStatus("Publish"),
                                    downloadWord: () => handleDownload("docx"),
                                    downloadPDF: () => handleDownload("pdf"),
                                    obsolete: () => handleWorkflowChangeStatus("Obsolete"),
                                  }}
                                  context="document"
                                />
                              </>
                          }
                        </div>
                      </div>
                      <Row className="mt-4">
                        <Col md="3">
                          <Controller
                            name="template"
                            control={control}
                            rules={{
                              required: fieldsMessage.required("Template"),
                            }}
                            render={({ field }) => (
                              <TemplateSelect
                                value={field.value}
                                onChange={field.onChange}
                                editable={idHistory || !editableWithSave}
                              />
                            )}
                          />
                          <p className="error-form">
                            {errors.template?.message}
                          </p>
                        </Col>
                        <Col md="3">
                          <Label className="label-detail-form">
                            Document Type
                          </Label>
                          <Controller
                            name="type"
                            control={control}
                            rules={{
                              required: fieldsMessage.required("Document type"),
                            }}
                            render={({ field }) => (
                              <Select
                                className="filter-select"
                                components={{ ClearIndicator: CustomClear }}
                                options={optionsTypesDocument}
                                value={optionsTypesDocument.find(
                                  (opt) => opt.value === field.value?.value,
                                )}
                                isClearable
                                onChange={field.onChange}
                                placeholder={"Select document type"}
                                isDisabled={idHistory !== null || !editableWithSave}
                                styles={customStyles}
                              />
                            )}
                          />
                          <p className="error-form">{errors.type?.message}</p>
                        </Col>
                        <Col md="3">
                            <Label className="label-detail-form">Created By</Label>
                            <input 
                              className="form-control"
                              id="createUser"
                              {...register("createUser")}
                              disabled
                              style={{ color: '#00000060'}}
                            />
                        </Col>
                        <Col md="3">
                          <FormGroup className="mb-3">
                            <Label className="label-detail-form">
                              Creation Date
                            </Label>
                            <input
                              className="form-control"
                              {...register("createDate")}
                              disabled
                              style={{ color: '#00000060'}}
                            />
                          </FormGroup>
                        </Col>
                        
                      </Row>
                      
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label className="label-detail-form">Title</Label>
                            <input
                              className="form-control"
                              disabled={idHistory !== null || !editableWithSave}
                              style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                              placeholder="Document title"
                              {...register("title", {
                                required:
                                  fieldsMessage.required("Document title"),
                                validate: (value) =>
                                  value.trim() !== "" ||
                                  fieldsMessage.required("Document title"),
                                maxLength: {
                                  value: 100,
                                  message: fieldsMessage.maxLength(
                                    "Document title",
                                    100,
                                  ),
                                },
                              })}
                            />
                            <p className="error-form">
                              {errors.title?.message}
                            </p>
                          </FormGroup>
                        </Col>
                        <Col md="3">
                            <Label className="label-detail-form">Updated By</Label>
                            <input 
                              className="form-control"
                              id="updateUser"
                              {...register("updateUser")}
                              disabled
                              style={{ color: '#00000060'}}
                            />
                        </Col>
                        <Col md="3">
                          <FormGroup className="mb-3">
                            <Label className="label-detail-form">
                              Update Date
                            </Label>
                            <input
                              className="form-control"
                              {...register("updateDate")}
                              disabled
                              style={{ color: '#00000060'}}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col md="3">
                          <Controller
                            name="region"
                            control={control}
                            rules={{
                              required: fieldsMessage.required("Region"),
                            }}
                            render={({ field }) => (
                              <RegionSelect
                                value={field.value}
                                onChange={field.onChange}
                                editable={idHistory || !editableWithSave}
                              />
                            )}
                          />
                          <p className="error-form">{errors.region?.message}</p>
                        </Col>

                        <Col md="3">
                          <Controller
                            name="business"
                            control={control}
                            rules={{
                              required: fieldsMessage.required("Business"),
                            }}
                            render={({ field }) => (
                              <BusinessSelect
                                value={field.value}
                                onChange={field.onChange}
                                editable={idHistory || !editableWithSave}
                              />
                            )}
                          />
                          <p className="error-form">
                            {errors.business?.message}
                          </p>
                        </Col>
                        {(id !== null || idHistory !== null) && (
                          <Col md="6">
                            <Label className="label-detail-form">Status</Label>
                            <StatusList status={document?.status} />
                          </Col>
                        )}
                      
                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label className="label-detail-form">
                              Description
                            </Label>
                            <input
                              className="form-control"
                              disabled={idHistory !== null || !editableWithSave}
                              style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                              placeholder="Document description"
                              {...register("description")}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label className="label-detail-form">Product</Label>
                            <input
                              className="form-control"
                              disabled={idHistory !== null || !editableWithSave}
                              style={(idHistory !== null) || (!editableWithSave) ? {color: "#00000060"} : {}}
                              placeholder="Product name"
                              {...register("products", {
                                required:
                                  fieldsMessage.required("Product name"),
                                validate: (value) =>
                                  value.trim() !== "" || fieldsMessage.required("Product name"),
                                  maxLength: {
                                    value: 100,
                                    message: fieldsMessage.maxLength(
                                      "Product name",
                                      100,
                                  ),
                                },
                              })}
                            />
                            <p className="error-form">
                              {errors.products?.message}
                            </p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <hr
                            style={{ marginBottom: "30px", marginTop: "40px" }}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Col md="12">
                      {(!loadingDocument && !loadingWorkflow) && (
                        <Label className="label-detail-form">
                          Document Content{" "}
                          {!!contentError && (
                            <span className="error-form">
                              Content is required.
                            </span>
                          )}
                        </Label>
                      )}
                      <DocumentBuider
                        variant={documentBuilderVariants.DOCUMENT}
                        initialSelectedItems={document?.content || []}
                        handleChange={handleBuilderChange}
                        parentId={id}
                        loading={loadingDocument || loadingWorkflow}
                        disabled={idHistory !== null || !editableWithSave}
                        error={!!contentError}
                      />
                    </Col>
                  </Row>

                  {(!loadingDocument && !loadingWorkflow) && (
                    <>
                      <Row className="mt-4">
                      <Col md="12">
                        <div className="d-flex align-items-center gap-2">
                          <CheckboxField
                            id="active"
                            name="active"
                            register={register}
                            editable={idHistory !== null || !editableWithSave}
                          />
                          <LabelWithHelp
                            htmlFor="active"
                            label="Active"
                            typeMessage="active"
                            entity="document"
                            className="mb-0"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end my-4 gap-2">
                      <ButtonCustom
                        type="cancel"
                        onClick={() => handleBack()}
                      />
                      <ActionButtons 
                        actions={actions}
                        status={document?.status}
                        handlers={{
                          preview: () => handlePreview(),
                          save: () => handleSave(getValues()),
                          downloadWord: () => handleDownload("docx"),
                          downloadPDF: () => handleDownload("pdf"),
                        }}
                        context="document"
                      />
                    </div>
                    </>
                  )}
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const optionsTypesDocument = [
  { value: "RIS", label: "RIS" },
  { value: "PSIS", label: "PSIS" },
];

const mapStateToProps = ({
  DocumentReducer: {
    document,
    loadingDocument,
    messageDocument,
    isDocumentSave,
    documentIdDuplicate,
    errorDocumentDuplicate,
    errorLoadingDocument,
    errorLoadingDocumentHistory,
    documentPreview,
    errorDocumentPreview,
    documentDownload,
    errorDocumentDownload,
  },
  WorkflowReducer: {
    workflow,
    loadingWorkflow,
    errorMessageWorkflow,
  }
}) => ({
  document,
  loadingDocument,
  messageDocument,
  isDocumentSave,
  documentIdDuplicate,
  errorDocumentDuplicate,
  errorLoadingDocument,
  errorLoadingDocumentHistory,
  documentPreview,
  errorDocumentPreview,
  documentDownload,
  errorDocumentDownload,

  workflow,
  loadingWorkflow,
  errorMessageWorkflow,
});

const mapDispatchToProps = {
  saveDocumentRequest: saveDocument.request,
  getDocumentRequest: getDocument.request,
  getDocumentHistoryRequest: getDocumentHistory.request,
  postDocumentDuplicateRequest: duplicateDocument.request,
  getDocumentPreviewRequest: getDocumentPreview.request,
  putWorkflowChangeStatusRequest: putWorkflowChangeStatus.request,
  getDownloadDocumentRequest: getDownloadDocument.request,
  cleanMessageWorkflow, 
  loadEmptyDocument,
  cleanMessageDocument,
  disableLoadingDocument,
  cleanIdDocumentDuplicate,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDetail);